import { useState } from "react";
import { ScrollView } from "react-native";
import { graphql, useLazyLoadQuery } from "react-relay";
import { Input, useBoxStyle } from "arkh";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { EmployeeRoleEditEmployeesListItem } from "./EmployeeRoleEditEmployeesListItem";
import { EmployeeRoleEditEmployeesDialog } from "./EmployeeRoleEditEmployeesDialog";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { EmployeeRoleEditComponentContentQuery } from "./__generated__/EmployeeRoleEditComponentContentQuery.graphql";

type StateProps = {
  employeeIds: string[];
  name: string;
  setName: (name: string) => void;
  setEmployeeIds: (employeeIds: string[]) => void;
  teamId: string;
  autoFocusName?: boolean;
};

function EmployeeRoleEditComponentContent(
  props: {
    fetchKey: string;
    openEmployeesSelector: () => void;
  } & Omit<StateProps, "teamId">
) {
  const intl_tokens = useIntlTokens();
  const contentContainerStyle = useBoxStyle({
    space: "medium",
  });

  const data = useLazyLoadQuery<EmployeeRoleEditComponentContentQuery>(
    graphql`
      query EmployeeRoleEditComponentContentQuery($employeeIds: [ID!]!) {
        ...EmployeeRoleEditEmployeesListItem_query
      }
    `,
    {
      employeeIds: props.employeeIds,
    },
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  return (
    <ScrollView
      contentInsetAdjustmentBehavior="automatic"
      style={{ flex: 1 }}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={contentContainerStyle}
    >
      <Input
        autoFocus={props.autoFocusName}
        autoCapitalize="words"
        placeholder={intl_tokens.Name}
        value={props.name}
        onChangeText={props.setName}
        style={{
          flex: 1,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      />

      <EmployeeRoleEditEmployeesListItem
        data={data}
        openEmployeesSelector={props.openEmployeesSelector}
      />
    </ScrollView>
  );
}

export function EmployeeRoleEditComponent(props: StateProps) {
  const [employeesDialogVisible, setEmployeesDialogVisible] = useState(false);

  return (
    <>
      <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
        {(fetchKey) => (
          <EmployeeRoleEditComponentContent
            fetchKey={fetchKey}
            openEmployeesSelector={() => setEmployeesDialogVisible(true)}
            employeeIds={props.employeeIds}
            name={props.name}
            setName={props.setName}
            setEmployeeIds={props.setEmployeeIds}
            autoFocusName={props.autoFocusName}
          />
        )}
      </LazyQueryNetworkBoundrary>
      <EmployeeRoleEditEmployeesDialog
        visible={employeesDialogVisible}
        onClose={() => setEmployeesDialogVisible(false)}
        assignEmployeesIds={props.employeeIds}
        setAssignEmployeesIds={props.setEmployeeIds}
        teamId={props.teamId}
      />
    </>
  );
}
